import { render } from "./ManagementPlanDiagnosesGroup.vue?vue&type=template&id=11521623&ts=true"
import script from "./ManagementPlanDiagnosesGroup.vue?vue&type=script&lang=ts"
export * from "./ManagementPlanDiagnosesGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__